module.exports = __webpack_public_path__ + "static/media/automation.active.e9e5824c.svg";